import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=1f50acef&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=1f50acef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50acef",
  null
  
)

export default component.exports